export enum EFormatText {
    BOLD = 'bold',
    ITALIC = 'italic',
    UNDERLINE = 'underline',
    STRIKETHROUGH = 'strikethrough'
}

export enum EFormatElement {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right'
}

export enum EFormatIncreaseDecrease {
    INCREASE = 'increase',
    DECREASE = 'decrease'
}
